module.exports = __webpack_public_path__ + "img/zan.d9858d15.svg";